export default __webpack_public_path__ + "static/media/slider-1.4b646aea.jpg";